// extracted by mini-css-extract-plugin
module.exports = {"container":"promotionPopUp_container__mQSCA","swiper":"promotionPopUp_swiper__MV9OU"};